import type { PatchPageStructure } from '../types'
import { createTrialCtaDynamic } from '../../helpers/trial-cta'

const patchPageStructure: PatchPageStructure = (
  pageStructure,
  experimentService,
  _userService,
  _browserService,
  _facadeService,
  _pageSlug
) => {
  const toolsLtvNavVariant = experimentService.getToolsLtvNavAssignment()

  if (toolsLtvNavVariant === 'test') {
    const trialCta = createTrialCtaDynamic()

    return {
      ...pageStructure,
      fields: {
        ...pageStructure.fields,
        header: {
          ...(pageStructure.fields?.header || {}),
          fields: {
            ...(pageStructure.fields?.header?.fields || {}),
            stickyCtas: [trialCta],
          },
        },
      },
    }
  }

  return pageStructure
}

export const TrialEligibilityCtaExperiment = {
  patchPageStructure,
}
